import { render, staticRenderFns } from "./coderInpatientDxs.vue?vue&type=template&id=f64e5e62&scoped=true&"
import script from "./coderInpatientDxs.vue?vue&type=script&lang=js&"
export * from "./coderInpatientDxs.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientDxs.vue?vue&type=style&index=0&id=f64e5e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64e5e62",
  null
  
)

export default component.exports